import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch } from '@/redux/hooks';
import { trackPageView } from '@/redux/modules/analytics/analytics.actions';
import { getIdFromPath, getItemIdFromPath } from '@/utils/urls';

import { sailthruTrack } from './utils//sailthru';

const TRACKING_DELAY_MS = 1500;

export const PageTracker = () => {
    const dispatch = useAppDispatch();
    const { pathname, search } = useLocation();

    const itemId = getItemIdFromPath(pathname) || 0;
    const catalogId = !itemId ? getIdFromPath(pathname) : 0;

    useEffect(() => {
        const pageViewTimeout = setTimeout(() => {
            dispatch(trackPageView({ catalogId, itemId }));
            sailthruTrack(pathname);
        }, TRACKING_DELAY_MS);

        return () => clearTimeout(pageViewTimeout);
    }, [catalogId, dispatch, itemId, pathname, search]);

    return null;
};
